import React from "react";
import { Route, Redirect } from "react-router-dom";

export default ({ component: Component, ...rest }) => {
  const token = localStorage.token;
  return <Route
    {...rest}
    render={() => (token ? <Component/> : <Redirect to="/login"/>)}
  />
}


// WEBPACK FOOTER //
// ./src/privateRoute.js